import React, { useState, useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import useCustomNavigate from "./../hooks/useCustomNavigate";
import usePermission from "./../hooks/usePermission";
import axios from "./../services/http";
import config from "./../config";
import { NumericFormat } from 'react-number-format';
import { DeleteOutlined, UploadOutlined } from '@ant-design/icons';
import { Breadcrumb, Layout, Row, Col, Card, Form, Select, message, Button, Modal, Input, Divider, Upload, Switch } from 'antd';
import { jwtDecode } from 'jwt-decode';
const { Content } = Layout;

function PaymentControlForm () {

    //Permisos
    const canChooseRelat = usePermission({ permission: "elegir_relacion" });

    const location = useLocation();
    const { from } = location.state;
    const { id } = useParams();
    const navigate = useCustomNavigate();
    const [messageApi, contextHolder] = message.useMessage();
    const [form] = Form.useForm();
    const [contratistaForm] = Form.useForm();
    const [construction, setConstruction] = useState(from);
    const [catRelaciones, setCatRelaciones] = useState([]);
    const [openDialog, setOpenDialog] = useState(false);
    const [builders, setBuilders] = useState([]);
    const [cpArchivos, setCpArchivos] = useState([]);
    const [cpArchivosEdit, setCpArchivosEdit] = useState([]);
    const [anticipo, setAnticipo] = useState(false);
    const [loading, setLoading] = useState(false);
    const [disabledIVA, setDisabledIVA] = useState(false);
    const token = localStorage.getItem('token') || null;
    const numberFormat = new Intl.NumberFormat('es-MX', {minimumFractionDigits: 2});
    const props = {
        action: `${config.server}/api/v1/payments/upload-documents`,
        headers: {
            "Authorization": `Bearer ${token}`
        },
        onChange(info) {
            setLoading(true);
            //let newFileList = [...info.fileList];
            setCpArchivos(info.fileList);
            form.setFieldsValue({ rutaImagenPresupuesto: "" });
            form.setFieldsValue({ rutaImagenAutorizacion: "" });
            setLoading(false);
            // newFileList = newFileList.map((file) => { return file.response.path });
            // setCpArchivos(newFileList);
            // setLoading(false);
            // Opcional: filtrar solo archivos subidos exitosamente
            // newFileList = newFileList.map((file) => {
            // if (file.response) {
            //     //form.setFieldsValue({ rutaImagenPresupuesto: file.response.path });
            //     //form.setFieldsValue({ rutaImagenAutorizacion: file.response.path });
            //     setCpArchivos([...cpArchivos, file.response.path]);
            // }
            // return file;
            // });
        },
        onDownload(file) {
            let path = config.server + '/static/documents/' + form.getFieldValue("rutaImagenPresupuesto");
            window.open(path, '_blank');
        },
        accept: "application/pdf,image/png,image/jpej,image/jpg",
        showUploadList: {
          extra: ({ size = 0 }) => (
            <span
              style={{
                color: '#cccccc',
              }}
            >
              ({(size / 1024 / 1024).toFixed(2)}MB)
            </span>
          ),
          showDownloadIcon: true,
          downloadIcon: 'Ver',
          showRemoveIcon: true,
          removeIcon: <DeleteOutlined onClick={(e) => DeleteFile() } />,
        },
    };

    const DeleteFile = async () => {
        try {
            const response = await axios.HTTP_POST("/api/v1/extras/delete-document", { path: `static/documents/${form.getFieldValue("rutaImagenPresupuesto")}` });
            if (response && response.data && response.data.success) {
                form.setFieldsValue({ rutaImagenPresupuesto: undefined });
                form.setFieldsValue({ rutaImagenAutorizacion: undefined });
            }
        } catch (e) {
            console.error('Error al eliminar el archivo:', e);
            message.error(e);
        }
    }

    const GetBuilders = async () => {
        try {
          const response = await axios.HTTP_GET(`/api/contratistas/${construction.id}`);
          if (response) setBuilders(response);
        } catch (error) {
          console.error('Error al cargar los contratistas:', error);
        }
    };

    const GetPaymentInfo = async () => {
        try {
            const response = await axios.HTTP_GET(`/api/v1/payments/byId/${id}`);
            if (response && response.length >= 1) {
                let archivos = [];
                form.setFieldsValue({ contratistaId: response[0].contratista_id });
                form.setFieldsValue({ concepto: response[0].concepto });
                form.setFieldsValue({ descripcion: response[0].descripcion });
                form.setFieldsValue({ presupuesto: response[0].presupuesto });
                form.setFieldsValue({ presupuestoIva: response[0].presupuesto_iva });
                form.setFieldsValue({ presupuestoNoIva: response[0].presupuesto_no_iva });
                form.setFieldsValue({ iva: response[0].iva });
                for (let i = 0; i < response[0].archivos.length; i++) {
                    archivos.push({ 
                        uid: response[0].archivos[i].id, 
                        name: response[0].archivos[i].ruta, 
                        status: "done",
                        url: `${config.server}/static/documents/${response[0].archivos[i].ruta}`
                    });
                }
                setCpArchivosEdit(archivos);
                props.defaultFileList = archivos;
            }
        } catch (e) {
            console.error('Error al cargar la información del CP:', e);
            message.error(e);
        }
    }

    const fetchRelacion = async () => {
        try {
        const response = await axios.HTTP_GET(`/api/relacion-semanal/${from.id}`);
        let relaciones = [];
        for(let i = 1; i <= response.numeroRelacion; i++) relaciones.push({value:i});
        setCatRelaciones(relaciones);
        } catch (error) {
        console.error('Error al obtener la relación:', error);
        }
    };

    useEffect(() => {
        if (id !== undefined) GetPaymentInfo();
    }, [id]);

    useEffect(() => {
        console.log("Estado actualizado de archivos:", cpArchivosEdit);
    }, [cpArchivosEdit, props]);
    
    useEffect(() => {
        fetchRelacion();
        GetBuilders();
    }, []);

    const handleSubmit = async (values) => {
        try {
            setLoading(true);
            messageApi.open({ type: 'loading', content: 'Guardando control de pago....', duration: 0 });
            const {
                contratistaId,
                concepto,
                descripcion,
                presupuesto,
                presupuestoIva,
                presupuestoNoIva,
                iva,
                partidas,
                rutaImagenPresupuesto,
                rutaImagenAutorizacion,
                anticipo,
                anticipoFiscal,
                anticipoNoFiscal,
                relacionAntFis,
                relacionAntNoFis
            } = values;

            const nuevoControlDePago = {
                obra_id: construction.id,
                obra_nombre: construction.nombre_obra,
                contratista_id: contratistaId,
                concepto,
                descripcion,
                presupuesto: (typeof presupuesto === "string" ? parseFloat(presupuesto.replace(/[$,]/g,'')).toFixed(2) : presupuesto),
                presupuesto_iva: presupuestoIva,
                presupuesto_no_iva: presupuestoNoIva,
                iva: (iva !== undefined ? iva : 0),
                partidas,
                ruta_imagen_presupuesto: rutaImagenPresupuesto,
                ruta_imagen_autorizacion: rutaImagenAutorizacion,
                archivos: cpArchivos,
                id_usuario: jwtDecode(localStorage.getItem("token")).id,
                anticipo,
                anticipoFiscal: (typeof anticipoFiscal === "string" ? parseFloat(anticipoFiscal.replace(/[$,]/g,'')).toFixed(2) : anticipoFiscal),
                anticipoNoFiscal: (typeof anticipoNoFiscal === "string" ? parseFloat(anticipoNoFiscal.replace(/[$,]/g,'')).toFixed(2) : anticipoNoFiscal),
                relacionAntFis,
                relacionAntNoFis
            };
            console.log("nuevoControlDePago***",nuevoControlDePago, cpArchivosEdit);
            if (id !== undefined) {
                nuevoControlDePago["id"] = id;
                let band = false;
                for (let i = 0; i < cpArchivosEdit.length; i++) {
                    if (cpArchivosEdit[i].response && cpArchivosEdit[i].response.path) band = true;
                }
                if (!band) nuevoControlDePago["archivos"] = cpArchivosEdit;
            }
            let url = id !== undefined ? "/api/v1/payments/update" : "/api/v1/payments/save";
            const response = await axios.HTTP_POST(url, nuevoControlDePago);
            if (response) {
                messageApi.destroy();
                message.success(response.data.message);
                navigate("/home", { state: { from: from } })
            }
        } catch (error) {
          console.error('Error al añadir el gasto:', error);
          message.error('Hubo un error al añadir el gasto');
        } finally {
            setLoading(false);
        }
    };

    const onValuesChange = (changedValues) => {
        if ('presupuestoIva' in changedValues) {
          const restante = 100 - parseFloat(changedValues.presupuestoIva || 0);
          form.setFieldsValue({ presupuestoNoIva: restante.toFixed(2) });
          if (restante === 100 || restante === 100.00) {
            form.setFieldsValue({ iva: 0 });
            form.setFieldValue({ anticipoFiscal: 0 });
            setDisabledIVA(true);
          } else if (restante >= 0) {
            form.setFieldsValue({ iva: null });
            setDisabledIVA(false);
          }
        }
        if ('presupuestoNoIva' in changedValues) {
          const restante = 100 - parseFloat(changedValues.presupuestoNoIva || 0);
          form.setFieldsValue({ presupuestoIva: restante.toFixed(2) });
          if ((restante === 0||restante === 0.00) || restante < 0) {
            form.setFieldsValue({ iva: null });
            setDisabledIVA(true);
          } else {
            form.setFieldsValue({ iva: null });
            setDisabledIVA(false);
          }
        }
        // if ("anticipoFiscal" in changedValues || "anticipoNoFiscal" in changedValues) {
            
        //     const anticipoNoFiscal = typeof form.getFieldValue("anticipoNoFiscal") === "string" ? parseFloat(form.getFieldValue("anticipoNoFiscal").replace(/[$,]/g,'')) : form.getFieldValue("anticipoNoFiscal");
        //     const anticipoFiscal = typeof form.getFieldValue("anticipoFiscal") === "string" ? parseFloat(form.getFieldValue("anticipoFiscal").replace(/[$,]/g,'')) : form.getFieldValue("anticipoFiscal");
        //     const presupuesto = typeof form.getFieldValue("presupuesto") === "string" ? parseFloat(form.getFieldValue("presupuesto").replace(/[$,]/g,'')) : form.getFieldValue("presupuesto");

        //     console.log("anticipoNoFiscal:", (anticipoNoFiscal + anticipoFiscal), presupuesto);

        //     if ((anticipoNoFiscal + anticipoFiscal) > presupuesto) {
        //         message.error("El anticipo no puede ser mayor al presupuesto total.");
        //     }
        // }
    };

    const toNumber = (val) => {
        if (typeof val === "number") return val;
        if (!val) return 0;
        return parseFloat(val.toString().replace(/[$,\s]/g, "")) || 0;
    };

    const onChange = checked => {
        form.setFieldsValue({ anticipo: checked });
        setAnticipo(checked);
    };

    const handleAddContratista = async (values) => {
        const { nuevoContratista } = values;
    
        if (!construction.id) {
          message.error('Error: Debes elegir una obra.');
          return;
        }
    
        try {
          const response = await axios.HTTP_POST('/api/contratistas', {
            nombre_contratista: nuevoContratista,
            obra_id: construction.id,
          });

          if (response) {
            setBuilders([...builders, response.data]);
            contratistaForm.resetFields();
            form.setFieldsValue({ contratistaId: response.data.id });
            setOpenDialog(false);
            message.success('Contratista añadido exitosamente');
            
          }
        } catch (error) {
          console.error('Error al añadir el contratista:', error);
          message.error('Hubo un error al añadir el contratista');
        }
    };

    const Navigate = (path, params) => {
        navigate(path, params);
    }

    return (
        <>
            <Layout>
                <Content
                    className='primary-container'
                >
                    <Breadcrumb 
                        className='breadcrumb' 
                        items={[
                            { title: <a href="/home">Inicio</a> },
                            { title: "Nuevo Control de Pago" }
                        ]} 
                    />
                    <div 
                    className='container-content'
                    >
                        <Row gutter={[8, 8]} justify="center">
                            <Col xs={{ flex: '100%' }} md={{ flex: '60%' }} xl={{ flex: '40%' }}>
                                <Card title={`${(id !== undefined) ? "Edición" : "Nuevo"} Control de Pago - (${ construction.nombre_obra })`}>
                                    <Form
                                    layout="vertical"
                                        form={form}
                                        onFinish={handleSubmit}
                                        onValuesChange={onValuesChange}
                                    >
                                        <Form.Item
                                            label="Seleccionar Contratista"
                                            name="contratistaId"
                                            rules={[{ required: true, message: 'Por favor selecciona un contratista' }]}
                                        >
                                            <Select
                                                placeholder="Selecciona una opción"
                                                dropdownRender={(menu) => (
                                                <>
                                                {menu}
                                                <Button type="link" onClick={() => setOpenDialog(true)}>
                                                    Nuevo contratista
                                                </Button>
                                                </>
                                                )}
                                            >
                                                {builders.map((contratista) => (
                                                    <Select.Option key={contratista.id} value={contratista.id}>
                                                        {contratista.nombre_contratista}
                                                    </Select.Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                        <Form.Item
                                            label="Concepto"
                                            name="concepto"
                                            rules={[{ required: true, message: 'Por favor ingresa el concepto' }]}
                                        >
                                            <Input />
                                        </Form.Item>
                                        <Form.Item
                                            label="Descripción"
                                            name="descripcion"
                                            rules={[{ required: true, message: 'Por favor ingresa la descripción' }]}
                                        >
                                            <Input />
                                        </Form.Item>
                                        <Form.Item
                                            label="Presupuesto Inicial"
                                            name="presupuesto"
                                            rules={[{ required: true, message: 'Por favor ingresa el presupuesto inicial' }]}
                                        >
                                            {/* <Input type="number"  /> */}
                                            <NumericFormat 
                                                thousandSeparator={true} prefix={'$ '} 
                                                customInput={Input}
                                            />
                                        </Form.Item>
                                        <Form.Item
                                            label="Presupuesto con IVA (%)"
                                            name="presupuestoIva"
                                            rules={[{ required: true, message: 'Por favor ingresa el presupuesto con IVA' }]}
                                        >
                                            <Input type="number" />
                                        </Form.Item>
                                        <Form.Item
                                            label="Presupuesto sin IVA (%)"
                                            name="presupuestoNoIva"
                                            rules={[{ required: true, message: 'Por favor ingresa el presupuesto sin IVA' }]}
                                        >
                                            <Input type="number" />
                                        </Form.Item>
                                        {!disabledIVA?
                                            <Form.Item
                                                label="IVA"
                                                name="iva"
                                                rules={[{ required: true, message: 'Por favor selecciona el IVA' }]}
                                            >
                                                <Select placeholder="Selecciona una opción" disabled={disabledIVA}>
                                                    <Select.Option value={8}>8%</Select.Option>
                                                    <Select.Option value={16}>16%</Select.Option>
                                                </Select>
                                            </Form.Item>
                                        :null}
                                        <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                            <Form.Item
                                                name="anticipo">
                                                <Switch onChange={onChange} /> Anticipo
                                            </Form.Item>
                                        </div>
                                        {anticipo && (
                                            <>
                                                {!disabledIVA ?
                                                    <>
                                                        <Form.Item
                                                            label="Anticipo fiscal"
                                                            name="anticipoFiscal"
                                                            rules={[
                                                                { required: true, message: 'Por favor ingresa el anticipo fiscal' },
                                                                {
                                                                    validator: (_, value) => {
                                                                        const anticipoFiscal = toNumber(value);
                                                                        const anticipoNoFiscal = toNumber(form.getFieldValue("anticipoNoFiscal"));
                                                                        const presupuesto = toNumber(form.getFieldValue("presupuesto"));

                                                                        if (anticipoFiscal + anticipoNoFiscal > presupuesto) {
                                                                            return Promise.reject("La suma de anticipos no puede ser mayor al presupuesto.");
                                                                        }

                                                                        return Promise.resolve();
                                                                    },
                                                                },
                                                            ]}
                                                        >
                                                            {/* <Input type="number"  /> */}
                                                            <NumericFormat 
                                                                thousandSeparator={true} prefix={'$ '} 
                                                                customInput={Input}
                                                            />
                                                        </Form.Item>
                                                        <Form.Item
                                                            label="Relación"
                                                            name="relacionAntFis"
                                                            rules= {[{required: true, message: 'Por favor selecciona una relación'}]}
                                                            >
                                                            <Select value="relacion" options={catRelaciones} />
                                                        </Form.Item>
                                                    </>
                                                :null}
                                                
                                                <Form.Item
                                                    label="Anticipo no fiscal"
                                                    name="anticipoNoFiscal"
                                                    rules={[
                                                        { required: true, message: 'Por favor ingresa el anticipo no fiscal' },
                                                        {
                                                            validator: (_, value) => {
                                                                const anticipoFiscal = toNumber(form.getFieldValue("anticipoFiscal"));
                                                                const anticipoNoFiscal = toNumber(value);
                                                                const presupuesto = toNumber(form.getFieldValue("presupuesto"));

                                                                if ((anticipoFiscal + anticipoNoFiscal) > presupuesto) {
                                                                    return Promise.reject("La suma de anticipos no puede ser mayor al presupuesto.");
                                                                }

                                                                return Promise.resolve();
                                                            },
                                                        },
                                                    ]}
                                                >
                                                    {/* <Input type="number"  /> */}
                                                    <NumericFormat 
                                                        thousandSeparator={true} prefix={'$ '} 
                                                        customInput={Input}
                                                    />
                                                </Form.Item>
                                                <Form.Item
                                                    label="Relación"
                                                    name="relacionAntNoFis"
                                                    rules= {[{required: true, message: 'Por favor selecciona una relación'}]}
                                                    >
                                                    <Select value="relacion" options={catRelaciones} />
                                                </Form.Item>
                                            </>
                                        )}
                                        {/* <Form.Item
                                            label="Partidas"
                                            name="partidas"
                                            rules={[{ required: true, message: 'Por favor ingrese las partidas' }]}
                                        >
                                            <Input />
                                        </Form.Item> */}
                                        <Form.Item
                                            label="Ruta Imagen Presupuesto"
                                            name="rutaImagenPresupuesto"
                                        >
                                            <Upload key={cpArchivosEdit.length} {...props} defaultFileList={[...cpArchivosEdit]}>
                                                <Button icon={<UploadOutlined />}>Subir archivo</Button>
                                            </Upload>
                                        </Form.Item>
                                        {/* <Form.Item
                                            label="Ruta Imagen Autorización"
                                            name="rutaImagenAutorizacion"
                                        >
                                            <Input />
                                        </Form.Item> */}
                                        <Divider style={{ margin: '24px 0' }} />
                                        <Form.Item>
                                            <div style={{ display: 'flex', justifyContent: 'end', gap: '10px' }}>
                                                <Button type="default" onClick={() => Navigate("/home", { state: { from: from } } )}>
                                                    Cancelar
                                                </Button>
                                                <Button type="primary" loading={loading} htmlType="submit">
                                                    Guardar
                                                </Button>
                                            </div>
                                        </Form.Item>
                                    </Form>
                                </Card>
                            </Col>
                        </Row>
                    </div>
                </Content>
            </Layout>
            <Modal
                title="Nuevo Contratista"
                open={openDialog}
                onCancel={() => setOpenDialog(false)}
                footer={null}
                >
                <Form
                    form={contratistaForm}
                    layout="vertical"
                    onFinish={handleAddContratista}
                >
                    <Form.Item
                    label="Nombre"
                    name="nuevoContratista"
                    rules={[{ required: true, message: 'Favor de ingresar el nombre' }]}
                    >
                    <Input />
                    </Form.Item>
                    <Form.Item>
                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button onClick={() => setOpenDialog(false)} style={{ marginRight: 8 }}>
                        Cancelar
                        </Button>
                        <Button type="primary" htmlType="submit">
                        Añadir
                        </Button>
                    </div>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    )
}

export default PaymentControlForm;